export const SET_APPOINTMENT_VALUES = 'DRSA/APPOINTMENT/SET_APPOINTMENT_VALUES';

export const initialState = {};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_APPOINTMENT_VALUES:
      return action.payload;
    default:
      return state;
  }
};

export const storeData = ({ payload }) => ({ type: SET_APPOINTMENT_VALUES, payload });

const actions = {
  storeData,
};

export default { reducer, actions };
